import { render, staticRenderFns } from "./ToastNotification.vue?vue&type=template&id=145d99c4&scoped=true"
import script from "./ToastNotification.vue?vue&type=script&lang=js"
export * from "./ToastNotification.vue?vue&type=script&lang=js"
import style0 from "./ToastNotification.vue?vue&type=style&index=0&id=145d99c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145d99c4",
  null
  
)

export default component.exports